/* metro-ui-components@9.20.0 */
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var PropTypes = require("prop-types");
var classnames = require("classnames");
if (!process.env.ALEX_UI_IGNORE_CSS) { require('./ContextualMenu.css'); }
var moduleClassNameFactory_1 = require("./util/moduleClassNameFactory");
var Description_1 = require("./Description");
var Icon_1 = require("./Icon");
var OutsideClick_1 = require("./util/OutsideClick");
var moduleClassName = moduleClassNameFactory_1.moduleClassNameFactory("m-contextualMenu");
exports.ContextualMenu = function ContextualMenu(_a) {
    var className = _a.className, children = _a.children, requestClose = _a.requestClose;
    return (React.createElement(OutsideClick_1.OutsideClick, { onOutsideClick: requestClose },
        React.createElement("div", { className: classnames(moduleClassName(), className) }, children)));
};
exports.ContextualMenu.propTypes = {
    requestClose: PropTypes.func.isRequired
};
exports.ContextualMenuList = function ContextualMenuList(_a) {
    var children = _a.children;
    return React.createElement("div", { className: moduleClassName("list") }, children);
};
exports.ContextualMenuButton = function ContextualMenuButton(_a) {
    var children = _a.children, className = _a.className, onClick = _a.onClick, selected = _a.selected;
    return (React.createElement("button", { onClick: onClick, className: classnames(moduleClassName("button"), selected && moduleClassName("button-isSelected"), className) },
        children,
        !!selected && (React.createElement(Icon_1.Icon, { type: "check", className: moduleClassName("selectedIcon") }))));
};
exports.ContextualMenuButton.propTypes = {
    selected: PropTypes.bool,
    onClick: PropTypes.func.isRequired,
    className: PropTypes.string
};
exports.ContextualMenuDescription = function ContextualMenuDescription(_a) {
    var children = _a.children;
    return (React.createElement(Description_1.Description, { className: moduleClassName("description") }, children));
};